var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stepper",style:({ backgroundColor: _vm.progressBackgroundColor })},[_c('div',{staticClass:"progress",style:(_vm.getProgressStyle)})])
}
var staticRenderFns = []

export { render, staticRenderFns }